import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { notification } from 'antd';

import { displayNewsHeadline, selectors } from 'state';
import { isV5MarketsLocation } from '../TraineeSession/MarketsTabV5/route';

const News: React.FC = () => {
  const lastNews = useSelector(selectors.lastNews);
  const lastNewsSource = useSelector(selectors.lastNewsSource);
  const session = useSelector(selectors.activeSession);
  const location = useLocation();
  const suppressNotifications = useRef(false);
  suppressNotifications.current = isV5MarketsLocation(
    location.pathname,
    session?.which_markets,
  );

  useEffect(() => {
    if (!lastNews) return;
    if (lastNewsSource === 'fetch') return; // don't display notifications when reloading or on first load
    if (suppressNotifications.current) return;
    Object.values(lastNews).forEach(news => {
      notification.info({
        message: displayNewsHeadline(news),
      });
    });
  }, [lastNews]);

  return null;
};

export default News;
